import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import successGif from "../assets/icons/success.gif";
import * as LoadingIcons from "react-loading-icons";

const Success = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  const [countdown, setCountdown] = useState(5); // 5 secondes avant redirection
  const [paymentConfirmed, setPaymentConfirmed] = useState(false);

  useEffect(() => {
    if (!sessionId) {
      navigate("/EspaceClient", { replace: true });
      return;
    }

    // On considère le paiement confirmé si session_id existe
    setPaymentConfirmed(true);

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/EspaceClient", { replace: true });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate, sessionId]);

  if (!paymentConfirmed) {
    return (
      <div className="h-screen flex flex-col items-center justify-center text-color1 text-center">
        <LoadingIcons.SpinningCircles
          stroke="#2218eeff"
          fill="#2218eeff"
          strokeWidth={3}
          height={50}
          width={50}
        />
        <p className="text-color1">Traitement du paiement...</p>
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col items-center justify-center bg-white text-color1 text-center p-4">
      <img src={successGif} alt="Paiement réussi" className="w-40 h-40 mb-6" />
      <h1 className="text-4xl font-bold mb-4">Paiement confirmé ✅</h1>
      <p className="text-xl mb-4">
        Votre paiement est confirmé. Vous serez redirigé vers le dashboard dans :
      </p>
      <p className="text-5xl font-bold mb-6">{countdown}</p>
    </div>
  );
};

export default Success;
